import { render } from "./active-filters-list.vue?vue&type=template&id=c67cd532"
import script from "./active-filters-list.vue?vue&type=script&lang=js"
export * from "./active-filters-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__